import { render, staticRenderFns } from "./TypeDetails.vue?vue&type=template&id=d035d6aa"
import script from "./TypeDetails.vue?vue&type=script&lang=js"
export * from "./TypeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports